import { ColumnDefinition } from '../../../../../../generic/universal-table/types/column.types'
import { ProductUiRow } from '../types/productTable.types'

export const productTableColumns: ColumnDefinition<ProductUiRow>[] = [
  {
    key: 'ProductID',
    title: 'קוד',
    dataType: 'number',
    width: '70px',
    sortable: true,
    editable: false,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'ProductDesc',
    title: 'שם פריט',
    dataType: 'string',
    width: '180px',
    sortable: true,
    editable: true,
    visible: true,
    required: true,
    cellRendererType: 'text',
  },
  {
    key: 'ProductDescEng',
    title: 'שם באנגלית',
    dataType: 'string',
    width: '160px',
    sortable: true,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'GeneralProductID',
    title: 'פריט כללי',
    dataType: 'number',
    width: '100px',
    sortable: true,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'ProductFamilyId',
    title: 'משפחה',
    dataType: 'number',
    width: '90px',
    sortable: true,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'AccountId',
    title: 'חשבון',
    dataType: 'number',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'ExternalNumber',
    title: 'ברקוד חיצוני',
    dataType: 'string',
    width: '120px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'PrintProductDesc',
    title: 'שם להדפסה',
    dataType: 'string',
    width: '160px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'PrintProductDesc_CLASS2',
    title: 'שם להדפסה (קלאס 2)',
    dataType: 'string',
    width: '180px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Active',
    title: 'פעיל',
    dataType: 'boolean',
    width: '70px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
    align: 'center',
  },
  {
    key: 'VAT',
    title: 'מע"מ',
    dataType: 'boolean',
    width: '70px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
    align: 'center',
  },
  {
    key: 'NoTagCollection',
    title: 'ללא סריקה',
    dataType: 'boolean',
    width: '80px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
  },
  {
    key: 'MandatoryWeight',
    title: ' חובת שקילה',
    dataType: 'boolean',
    width: '100px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Item_For_Stock',
    title: 'לפי מלאי',
    dataType: 'boolean',
    width: '80px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'CollectorSort',
    title: 'מיון לליקוט',
    dataType: 'number',
    width: '90px',
    sortable: true,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'PriseListSort',
    title: 'מיון מחירון',
    dataType: 'number',
    width: '100px',
    sortable: true,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'CalculationMethod',
    title: 'אופן חישוב',
    dataType: 'number',
    width: '110px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'CollectDeviation',
    title: 'סטיית קטיף',
    dataType: 'float',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'WastePercent',
    title: 'אחוז פחת',
    dataType: 'float',
    width: '90px',
    sortable: false,
    editable: true,

    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'ActivityType',
    title: 'סוג פעילות',
    dataType: 'number',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
]
